import $ from 'jquery'

function check_card_width() {
    $('.js-cta-image').each(function() {
        if ($(this).outerWidth(true) <= 500) {
            $(this).removeClass('feed-cta-card__use-img--big')
        }
        else {
            $(this).addClass('feed-cta-card__use-img--big')
        }
    });
}

check_card_width()
window.addEventListener('load', check_card_width)
window.addEventListener('resize', check_card_width)
